import { Component, inject, ChangeDetectionStrategy} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
    selector: 'gcp-workspace-custom-snack-bar',
    imports: [MatIcon],
    templateUrl: './custom-snack-bar.component.html',
    styleUrl: './custom-snack-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSnackBarComponent {
  public readonly snackBarRef = inject(MatSnackBarRef<CustomSnackBarComponent>);
  public readonly data = inject<{ message: string }>(MAT_SNACK_BAR_DATA);

  closeSnackBar() {
    this.snackBarRef.dismiss();
  }
}
